import { render } from "./gszx.vue?vue&type=template&id=bd18b1e4&scoped=true&ts=true"
import script from "./gszx.vue?vue&type=script&lang=ts"
export * from "./gszx.vue?vue&type=script&lang=ts"

import "./gszx.vue?vue&type=style&index=0&id=bd18b1e4&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd18b1e4"]])

export default __exports__